<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.142 5.929C16.97 4.757 15.435 4.172 13.899 4.172C12.363 4.172 10.828 4.758 9.656 5.929L6 9.586V6H4V13H11V11H7.414L11.071 7.343C11.4415 6.97042 11.8822 6.67501 12.3677 6.47384C12.8531 6.27267 13.3736 6.16974 13.899 6.171C14.967 6.171 15.972 6.587 16.727 7.343C17.4762 8.09367 17.897 9.11092 17.897 10.1715C17.897 11.2321 17.4762 12.2493 16.727 13L11.363 18.364L12.777 19.778L18.141 14.414C18.6983 13.857 19.1404 13.1956 19.4421 12.4677C19.7437 11.7398 19.899 10.9596 19.8991 10.1717C19.8992 9.38377 19.7441 8.60353 19.4426 7.87556C19.1411 7.14759 18.6992 6.48614 18.142 5.929Z" fill="currentColor"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGUndo',
};
</script>

<style scoped>

</style>
